/**
 * Profil so'rovlari — docs/API.md §4.
 *
 * Tiplar `@voice/api-client` dan, ular GENERATSIYA QILINADI (D-013).
 * Bu yerda faqat so'rov kalitlari va kesh mantiqi.
 */

import type { GiftShowcase, MeResponse, MeUpdateRequest } from '@voice/api-client';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { request } from './client';

export const ME_KEY = ['me'] as const;
export const ME_GIFTS_KEY = ['me', 'gifts'] as const;

export function useMe() {
  return useQuery({
    queryKey: ME_KEY,
    queryFn: () => request<MeResponse>('/me'),
    // Balans sovg'a va xariddan keyin o'zgaradi. Uzoq kesh eski raqamni
    // ko'rsatib turadi, shuning uchun qisqa.
    staleTime: 15_000,
  });
}

export function useMyGifts() {
  return useQuery({
    queryKey: ME_GIFTS_KEY,
    queryFn: () => request<GiftShowcase>('/me/gifts'),
    staleTime: 60_000,
  });
}

export function useUpdateMe() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (patch: MeUpdateRequest) =>
      request<MeResponse>('/me', { method: 'PATCH', body: patch }),
    // Javob to'liq profil — qayta so'rov shart emas, keshga to'g'ridan-to'g'ri
    // yoziladi.
    onSuccess: (fresh) => client.setQueryData(ME_KEY, fresh),
  });
}
